//@ts-nocheck
import { normalizeLocale } from './locale';

export const getSpellCheckLanguage = (...locales) => {
  return normalizeLocale(...locales);
};
